const Button = (props) => {
  const {
    className,
    title,
    type,
    onClick,
    secondaryType,
    styleOverride,
    isLoading,
    content,
    disabled,
    icon: Icon,
  } = props;
  const defaultClass = `transform active:scale-95 flex justify-center items-center focus:outline-none text-sm min-h-button-h tablet:text-base active:text-xl font-bold h-14 w-60  ${
    disabled ? " bg-txtGray " : " bg-gradient-to-r shadow-btnShadow"
  }  from-btnStart to-btnEnd text-white  rounded-2xl `;
  const secondaryClass =
    "transform active:scale-95 cursor-pointer bg-transparent text-sm min-h-button-h tablet:text-base border border-txtGray text-txtGray focus:outline-none active:scale-95 font-bold w-60  h-14  rounded-2xl ";

  const cursorClass = isLoading
    ? "cursor-not-allowed"
    : disabled
      ? "cursor-not-allowed"
      : "cursor-pointer";
  const buttonClass = secondaryType
    ? secondaryClass
    : defaultClass + cursorClass;

  return (
    <button
      className={styleOverride ? className : buttonClass + " " + className}
      onClick={onClick}
      disabled={isLoading || disabled}
      type={type ? type : "button"}
    >
      {!isLoading ? (
        content ? (
          content
        ) : (
          <span> {title}</span>
        )
      ) : (
        <div className=" animate-spin  ease-linear rounded-full border-4  h-8 w-8  border-top-color" />
      )}
      {Icon && <Icon />}
    </button>
  );
};

export default Button;
